import React from 'react'
import InputBox from './components/InputBox'

function General() {
  return (
      <div>
          <InputBox/>
    </div>
  )
}

export default General